import { render, staticRenderFns } from "./NatalLuz.vue?vue&type=template&id=6d65710d&scoped=true&"
import script from "./NatalLuz.vue?vue&type=script&lang=js&"
export * from "./NatalLuz.vue?vue&type=script&lang=js&"
import style0 from "./NatalLuz.vue?vue&type=style&index=0&id=6d65710d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d65710d",
  null
  
)

export default component.exports